import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Timestamp from './Timestamp';
import Octicon, {Location, Organization} from '@githubprimer/octicons-react';

class TournamentTile extends Component {
  componentDidMount() {
    const { tournament, dispatch } = this.props;
  }

  link() {
    return this.props.link === undefined ?
    '/tournaments/' + this.props.tournament.id + '/info' :
    this.props.link;
  }

  tournamentType() {
    const typeEnum = this.props.tournament.type;
    if (typeEnum === 'INDIVIDUAL') {
      return 'indywiduel';
    } else if (typeEnum === 'TEAMS') {
      return 'turniej teamów';
    } else {
      return 'turniej par';
    }
  }

  tournamentTypeClass() {
    const typeEnum = this.props.tournament.type;
    if (typeEnum === 'INDIVIDUAL') {
      return 'badge badge-warning mr-1';
    } else if (typeEnum === 'TEAMS') {
      return 'badge badge-success mr-1';
    } else {
      return 'badge badge-danger mr-1';
    }
  }

  tournamentRank() {
    const rankEnum = this.props.tournament.rank;
    if (rankEnum === 'OTP_THREE_STARS') {
      return 'OTP***';
    } else if (rankEnum === 'OTP_TWO_STARS') {
      return 'OTP**';
    } else if (rankEnum === 'OTP_ONE_STAR') {
      return 'OTP*';
    } else if (rankEnum === 'OTP') {
      return 'OTP';
    } else if (rankEnum === 'RTP_ONE_STAR') {
      return 'RTP*';
    } else if (rankEnum === 'RTP') {
      return 'RTP';
    } else {
      return '';
    }
  }

  tournamentRankClass() {
    const rankEnum = this.props.tournament.rank;
    if (rankEnum === 'OTP_THREE_STARS' || rankEnum === 'OTP_TWO_STARS' || rankEnum === 'OTP_ONE_STAR' || rankEnum === 'OTP') {
      return 'badge badge-dark mr-1';
    } else if (rankEnum === 'RTP_ONE_STAR' || rankEnum === 'RTP') {
      return 'badge badge-secondary mr-1';
    } else {
      return '';
    }
  }

  render() {
    const tournament = this.props.tournament;

    return (
      <div className="card p-2 m-2 tournament-tile">
        <div className="tournament-tile-row">
          <div className="tournament-buttons">
            {this.props.children}
          </div>
          <div className="d-flex justify-content-between">
            <div className="d-inline-block">
              <span className={this.tournamentTypeClass()}>{this.tournamentType()}</span>
              <span className={this.tournamentRankClass()}>{this.tournamentRank()}</span>
            </div>
            <div className="d-inline-block">
              <span className="tournament-short-description">
                <Octicon icon={Location}/> <span>{tournament.shortDescription}</span>
              </span>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div className="d-inline-block">
              <Link to={this.link()}><span className="tournament-name"><b>{tournament.name}</b></span></Link>
            </div>
            <div className="d-inline-block">
              <span className="ml-1 mr-1">
                <Octicon icon={Organization}/> <span><b>{tournament.registrationInfo.registeredParticipantCount}/{tournament.registrationInfo.participantLimit}</b></span>
              </span>
              <Timestamp value={new Date(Date.parse(tournament.startTime))} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TournamentTile;



// WEBPACK FOOTER //
// ./components/TournamentTile.js